module.exports = __webpack_public_path__ + "static/media/SCBcardPayment.4c5663b1.svg";